let video = document.querySelectorAll('.video');

const cookieBotVideoPlaceholderFallback = `
<div class="video__cookie-placeholder cookieconsent-optout-marketing">
  <h2>Sorry, deze video is niet beschikbaar</h2>
  <p>
    Deze video wordt geleverd door YouTube. Om deze content te kunnen tonen hebben wij uw goedkeuring nodig voor het gebruik van de cookies van YouTube.
  </p>
  <a class="link" href="javascript:Cookiebot.renew()"><span class="sec-icon sec-icon-arrow-right"></span>Wijzig cookievoorkeuren</a>
</div>`;

// Get Youtube thumbnailUrl by video-link
const Youtube = (url, size) => {
  let video, results;

  if (url === null) {
    return '';
  }
  size = size === null ? 'big' : size;
  results = url.match('[\\/&]embed/([^&#]*)');
  video = results === null ? url : results[1];

  if (size === 'small') {
    return 'https://img.youtube.com/vi/' + video + '/1.jpg';
  }
  return 'https://img.youtube.com/vi/' + video + '/hqdefault.jpg';
};

function YouTubeGetID(url) {
  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

if (video.length) {
  [].forEach.call(video, (el) => {
    //because of cookiebot we need to check if placeholder exists
    let placeholder = el.querySelector('.video__placeholder');
    let placeholderLink = placeholder.querySelector('.video__placeholder__trigger');
    let playButton = placeholderLink.querySelector('button');

    // Check if clicked element has a video url in the dataset
    let videoLink = el.dataset.video;
    if (videoLink) {
      let videoId = YouTubeGetID(videoLink);
      videoLink = `https://www.youtube.com/embed/${videoId}`;
      // Add playButton when there's no videoLink available
      playButton.classList.add('active');

      // Create cookiebot placeholder on the element
      const cookiePlaceholder = cookieBotVideoPlaceholder
        ? cookieBotVideoPlaceholder
        : cookieBotVideoPlaceholderFallback;

      el.insertAdjacentHTML('beforeend', cookiePlaceholder);

      placeholderLink.addEventListener('click', () => {
        // Remove play button on click
        playButton.classList.remove('active');

        // Create iframe
        let iframe = document.createElement('div');
        let autoPlay = '1';
        iframe.innerHTML =
          '<iframe src="' +
          videoLink +
          '?rel=0&autoplay=' +
          autoPlay +
          '&enablejsapi=1" class="youtube-video" frameborder="0" allow="autoplay; encrypted-media gyroscope; picture-in-picture" allowfullscreen data-cookieconsent="marketing"></iframe>';

        // Replace the anchor with the video
        placeholder.replaceChild(iframe, placeholderLink);
      });
    }

    if (!el.querySelector('img')) {
      const img = document.createElement('img');
      img.src = Youtube(`${videoLink}`, 'big');

      el.querySelector('.video__placeholder__trigger').insertBefore(
        img,
        el.querySelector('.video__content'),
      );
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const placeholders = document.querySelectorAll('.video__placeholder');

  placeholders.forEach(function (placeholder) {
    const trigger = placeholder.querySelector('.video__placeholder__trigger');
    const videoelement = placeholder.querySelector('.video--mp4');

    if (videoelement) {
      trigger.addEventListener('click', function () {
        videoelement.style.display = 'block';

        trigger.style.display = 'none';

        const button = trigger.querySelector('.video__button');
        if (button) {
          button.style.display = 'none';
        }

        videoelement.play();
      });
    }
  });
});

// specific iframe richtext logics
const iframes = document.querySelectorAll('iframe');
if (iframes.length) {
  [].forEach.call(iframes, (el) => {
    const src = el.getAttribute('src');

    if (src && src.indexOf('youtube.com/embed') !== -1) {
      const parent = el.parentNode;
      const markup = `<div class="video js-generated" data-video="${src}"><div class="video__placeholder" /></div>`;
      el.insertAdjacentHTML('afterend', markup);
      el.remove();

      // setup wallpaper image by getting the videoId
      const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
      const videoId = src.match(regExp)[1];
      const wallpaperImg = 'https://img.youtube.com/vi/' + videoId + '/sddefault.jpg';

      // add the wallpaper img
      const wallpaperContainer = parent.querySelector('.video__placeholder');
      wallpaperContainer.style.background = `url(${wallpaperImg}) center no-repeat`;
      wallpaperContainer.style.backgroundSize = 'cover';
      wallpaperContainer.insertAdjacentHTML(
        'beforeend',
        '<span class="cookieconsent-optin-marketing video__placeholder__trigger" />',
      );

      let iframe = document.createElement('div');
      let autoPlay = '1';
      iframe.innerHTML =
        '<iframe src="' +
        src +
        '?rel=0&autoplay=' +
        autoPlay +
        '&enablejsapi=1" class="youtube-video" frameborder="0" allow="autoplay; encrypted-media gyroscope; picture-in-picture" allowfullscreen data-cookieconsent="marketing"></iframe>';

      const playButton = wallpaperContainer.querySelector('.video__placeholder__trigger');
      playButton.addEventListener('click', () => {
        playButton.style.display = 'none';
        wallpaperContainer.prepend(iframe);
      });

      // cookieBotVideoPlaceholder is provided in a backend script to have it multilanguagal
      const placeHolder = cookieBotVideoPlaceholder
        ? cookieBotVideoPlaceholder
        : cookieBotVideoPlaceholderFallback;

      wallpaperContainer.insertAdjacentHTML('beforeend', placeHolder);
    }
  });
}
